import DataLoader from 'components/DataLoader';
import WindowResizeWatcher from 'components/WindowResizeWatcher';
import Component, {TableRow} from 'containers/GoneTableFrame/Component';
import React, {FC} from 'react';
import {getDataUrl} from 'utils/dataUrls';
import {makeReadConfigurator} from 'utils/makeConfigurator';

export type Data = {
  tableRows: TableRow[];
};

export type TestProps = {
  forceMobile?: boolean;
};

const GoneTableFrame: FC<TestProps> = (testProps: TestProps) => {
  return (
    <DataLoader<Data>
      urls={{
        tableRows: getDataUrl('./data/gone_table_data.csv'),
      }}
    >
      {(data: Data) => (
        <WindowResizeWatcher>
          {({width, height, isMobile, mobileMaxW}) => {
            const isMobile1 = testProps.forceMobile ?? isMobile;
            const conf = makeReadConfigurator({
              width,
              height,
              isMobile: isMobile1,
              mobileMaxW,
            });
            return <Component data={data} conf={conf} />;
          }}
        </WindowResizeWatcher>
      )}
    </DataLoader>
  );
};

export default GoneTableFrame;
